import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button'
import { Alert, AlertTitle } from '@material-ui/lab';
function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    paper: {
        margin: '1em',
        overflow: "scroll",
        position: 'absolute',
        width: "50%",
        height: "50%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function SimpleModal({ closeModal, warnings=[], cautions=[]}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    const [confirmedAlerts, confirmAlerts] = React.useState({})
    const warningsLi = warnings ? warnings.map(warning => {
        return <li key={`warning-li-${warning}`} style={{ marginBottom: '1em' }}>
            { confirmedAlerts[warning] !== true ? 
                <Alert severity="error" className="clickable" onClick={() => confirmAlerts({...confirmedAlerts, [warning]: true })}>
                    <AlertTitle>Warning</AlertTitle>
                    <strong>{warning}</strong>
                </Alert> 
                : 
                <Alert severity="success">
                    <AlertTitle>Warning Acknowledged</AlertTitle>
                    <strong>{warning}</strong>
                </Alert> 
            }
        </li>
        }) : null
    const cautionsLi = cautions ? cautions.map(caution => {
        return <li key={`caution-li-${caution}`} style={{ marginBottom: '1em' }}>
            {confirmedAlerts[caution] !== true ?
                <Alert severity="warning" onClick={() => confirmAlerts({ ...confirmedAlerts, [caution]: true })}>
                    <AlertTitle>Caution</AlertTitle>
                    <strong>{caution}</strong>
                </Alert>
                :
                <Alert severity="success">
                    <AlertTitle>Caution Acknowledged</AlertTitle>
                    <strong>{caution}</strong>
                </Alert>
            }
            </li>
        })
            : null
    return (
        <Modal
            open={true}
            disableEnforceFocus
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                <span>Click to acknowledge alerts prior to proceeding.</span>
                <ul>
                    {warningsLi}
                </ul>
                <ul>
                    {cautionsLi}
                </ul>
                {Object.values(confirmedAlerts).length === [...cautions, ...warnings].length ? <div className="flex max-width" style={{justifyContent: "flex-end", marginTop: "1em", height:"50px"}}>
                    <Button
                        variant="outlined"
                        onClick={() => closeModal()}
                    >
                        Continue
                    </Button>
                </div> : null}
            </div>
        </Modal>
    );
}
